export default class SurveyResponsesService {
  constructor(httpClient) {
    this.http = httpClient;
  }

  // 학생의 설문 응답 조회
  async findAllSurveyResponses(conditions = {}) {
    const queryParams = Object.entries(conditions)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");
    return this.http.fetch(`/api/surveyresponses/readall?${queryParams}`, {
      method: "GET",
    });
  }

  // 설문 응답 생성
  async createSurveyResponse(data) {
    return this.http.fetch("/api/surveyresponses/create", {
      method: "POST",
      body: JSON.stringify(data),
    });
  }

  // 설문 응답 수정
  async updateSurveyResponse(data) {
    return this.http.fetch("/api/surveyresponses/update", {
      method: "PUT",
      body: JSON.stringify(data),
    });
  }

  // 설문 응답과 답변 함께 생성/수정
  async createOrUpdateResponse(data) {
    return this.http.fetch("/api/surveyresponses/createorupdate", {
      method: "POST",
      body: JSON.stringify(data),
    });
  }

  // 제출 취소
  async cancelSubmission(data) {
    return this.http.fetch("/api/surveyresponses/cancel", {
      method: "PUT",
      body: JSON.stringify(data),
    });
  }

  // 응답 존재 확인
  async checkResponseExists(conditions) {
    const queryParams = Object.entries(conditions)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");
    return this.http.fetch(`/api/surveyresponses/checkexists?${queryParams}`, {
      method: "GET",
    });
  }

  // 설문 응답 삭제
  async deleteSurveyResponse(id) {
    return this.http.fetch("/api/surveyresponses/delete", {
      method: "DELETE",
      body: JSON.stringify({ id }),
    });
  }
}
